import React, { memo } from 'react';
import DocumentTitle from 'react-document-title';

import { ArticleFragmentFragment } from '~/generated-gql/generated-types';
import ArticleContainer from '../containers/article-container';

interface Props {
  article: ArticleFragmentFragment;
  slug: string;
  loading?: boolean;
}

export const ArticleFragment: React.FC<Props> = ({
  article,
  slug,
  loading,
}) => (
  <React.Fragment>
    <DocumentTitle title={article.seo?.title} />
    <ArticleContainer
      graphqlArticle={article}
      slug={slug}
      loading={loading ?? true}
    />
  </React.Fragment>
);

export const MemoizedArticleFragment = memo(ArticleFragment);
